module.exports = {
    '@jpdguzman'    : 'management',
    '@markflorendo' : 'technical',
    '@karlnylander' : 'design',
    '@joshuagalvez' : 'design',
    '@joshuafalco'  : 'design',
    '@lindseygrande': 'design',
    '@rachelmutia'  : 'design',
    '@inigodepaula' : 'content',
    '@annonculibrina': 'technical',
    '@markvicencio' : 'technical',
    '@rafaeltuano'  : 'design',
    '@renzbernardo' : 'design',
    '@angelicacasaul': 'design',
    '@dwezilmanuel' : 'technical',
    '@rozhelturgo'  : 'qa',
    '@noeldelacruz' : 'technical',
    '@itdepaula'    : 'content',
    '@jasanmiguel'  : 'design',
    '@aicaganhinhin': 'pmo',
    '@warrenyao'    : 'technical',
    '@conchui'      : 'technical',
    '@biancasantana': 'technical',
    '@winsletcueto' : 'qa',
    '@janelleyu'    : 'design',
    '@jiannejose'   : 'technical',
    '@IsabelleAlyssa': 'pmo',
    '@ejdelacruz'   : 'pmo',
    '@juliusmiguel' : 'technical',
    '@annaenriquez' : 'technical',
    '@migobundoc'   : 'pmo',
    '@michajimenez' : 'pmo',
    '@maclimlengco' : 'design',
    '@lorenzcapellan': 'technical',
    '@kimtan'       : 'pmo',
    '@donelleagudo' : 'design',
    '@ellaborlongan': 'technical',
    '@gabmamites'   : 'design',
    '@valerieuy'    : 'design',
    '@alexandriamesias': 'content',
    '@millettearan' : 'admin'
};